import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Collapse,
  InputAdornment
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams,
  useSearchParams,
  useLocation
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";
import { isMobile } from "react-device-detect";
import { Image, Table, Space } from "antd";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getOrders, getWarehouses, getVendors } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline, FilterList, FilterListOff, Search, Print } from "@mui/icons-material";
import moment from "moment/moment";
import DateRangePicker from "../../app/components/DateRangePicker";
import { debounce } from "lodash";
import OrdersTable from "../../app/components/OrdersTable";

export const OrdersList = ({
  getOrders,
  getWarehouses,
  user,
  warehouses,
  orders,
  getVendors,
  vendors,
  warehouseId,
  isLoading
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ops = searchParams.get("ops");
  const opsTitles = {
    delayedSla: "Delayed Order SLA",
    beforeNoon: "Confirmed before 12:00",
    inTransit: "In Transit",
  };
  const [status, setStatus] = React.useState(() => {
    if (searchParams.get("ops")) return null;
    const saved = sessionStorage.getItem('ordersList_status');
    return saved ? JSON.parse(saved) : null;
  });
  const [direction, setDirection] = React.useState(() => {
    if (searchParams.get("ops")) return null;
    const saved = sessionStorage.getItem('ordersList_direction');
    return saved ? JSON.parse(saved) : null;
  });
  const [vendorId, setVendorId] = React.useState(() => {
    if (searchParams.get("ops")) return null;
    const saved = sessionStorage.getItem('ordersList_vendorId');
    return saved ? JSON.parse(saved) : null;
  });
  const [page, setPage] = React.useState(() => {
    if (searchParams.get("ops")) return 1;
    const saved = sessionStorage.getItem('ordersList_page');
    return saved ? JSON.parse(saved) : 1;
  });
  const [isNavigatingBack, setIsNavigatingBack] = React.useState(false);
  const [isInitialLoad, setIsInitialLoad] = React.useState(true);
  const { t, i18n } = useTranslation();
  const [search, setSearch] = React.useState('');
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [showFilters, setShowFilters] = React.useState(false);
  const [showPrint, setShowPrint] = React.useState(false);

  // Handle browser back/forward navigation
  useEffect(() => {
    const handlePopState = () => {
      setIsNavigatingBack(true);
      const savedPage = sessionStorage.getItem('ordersList_page');
      if (savedPage) {
        setPage(JSON.parse(savedPage));
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  // Save state to sessionStorage whenever it changes
  useEffect(() => {
    if (ops) return;
    sessionStorage.setItem('ordersList_status', JSON.stringify(status));
  }, [status, ops]);

  useEffect(() => {
    if (ops) return;
    sessionStorage.setItem('ordersList_direction', JSON.stringify(direction));
  }, [direction, ops]);

  useEffect(() => {
    if (ops) return;
    sessionStorage.setItem('ordersList_vendorId', JSON.stringify(vendorId));
  }, [vendorId, ops]);

  useEffect(() => {
    if (ops) return;
    sessionStorage.setItem('ordersList_page', JSON.stringify(page));
  }, [page, ops]);

  // Initial data load
  useEffect(() => {
    if (isInitialLoad) {
      getOrders({ page, limit: 100, warehouseId, vendorId, direction: ops ? undefined : direction, status: ops ? undefined : status, ops: ops || undefined });
      getVendors({ page: 1, limit: 100 });
      getWarehouses({ page: 1, limit: 100 });
      setIsInitialLoad(false);
    }
  }, [isInitialLoad]);

  const buildOrdersParams = (pageNum, dateOverrides = {}) => {
    const rangeStart = dateOverrides.startDate !== undefined ? dateOverrides.startDate : startDate;
    const rangeEnd = dateOverrides.endDate !== undefined ? dateOverrides.endDate : endDate;
    return {
      page: pageNum,
      limit: 100,
      warehouseId,
      vendorId,
      direction: ops ? undefined : direction,
      status: ops ? undefined : status,
      ops: ops || undefined,
      search: search || undefined,
      startDate: ops ? undefined : (rangeStart ? rangeStart.format('YYYY-MM-DD') : undefined),
      endDate: ops ? undefined : (rangeEnd ? rangeEnd.format('YYYY-MM-DD') : undefined),
    };
  };

  // Handle page changes
  useEffect(() => {
    if (!isNavigatingBack && !isInitialLoad) {
      getOrders(buildOrdersParams(page));
    }
    setIsNavigatingBack(false);
  }, [page]);

  // Handle filter changes
  useEffect(() => {
    if (!isNavigatingBack && !isInitialLoad) {
      setPage(1);
      getOrders(buildOrdersParams(1));
    }
  }, [vendorId, direction, status, ops]);

  const handleSearch = (dateOverrides) => {
    setPage(1);
    getOrders(buildOrdersParams(1, dateOverrides));
  };

  const clearAllFilters = () => {
    setSearch('');
    setStartDate(null);
    setEndDate(null);
    setPage(1);
    getOrders({ page: 1, limit: 100, warehouseId });
  };

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 2, justifyContent: 'space-between' }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>{opsTitles[ops] || "Orders"}</Typography>
          <Box>
            <Button
              onClick={() => setShowFilters(!showFilters)}
              sx={{ ...main_button, my: 2, ml: 2 }}
            >
              {showFilters ? <FilterListOff sx={{ color: "var(--secondaryColor)" }} /> : <FilterList sx={{ color: "var(--secColor4)" }} />}
              Filters
            </Button>
          </Box>
        </Box>
        {ops && (
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Typography color="text.secondary">
                {ops === "delayedSla" && "Outbound orders still not handed to courier, confirmed more than 2 working days ago (Friday off), from 1 June 2026 onward."}
                {ops === "beforeNoon" && "Outbound orders confirmed today before 12:00 Cairo that are still New or Preparing."}
                {ops === "inTransit" && "Outbound orders heading to the customer (Picked Up, In Transit, Out for Delivery, or a delivery attempt), created from 1 June 2026 onward."}
              </Typography>
            </CardContent>
          </Card>
        )}
        <Collapse in={showFilters}>
          <Card sx={{ mb: 2 }}>
            <CardContent>
              <Box sx={{ display: "flex", flexDirection: "column", px: 5 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography>Search</Typography>
                    <MainInput
                      margin="normal"
                      fullWidth
                      placeholder="Search by order number or customer information"
                      value={search}
                      onChange={({ target }) => setSearch(target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleSearch}
                              edge="end"
                              sx={{ color: "var(--secColor4)" }}
                            >
                              <Search />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>Status</Typography>
                    <MainInput
                      fullWidth
                      value={status}
                      onChange={({ target }) => { setStatus(target.value) }}
                      displayEmpty
                      select
                      disabled={Boolean(ops)}
                      sx={{ mt: 1 }}
                    >
                      <MenuItem value={null}>All Statuses</MenuItem>
                      <MenuItem value={"New"}>{"New"}</MenuItem>
                      <MenuItem value={"Pending Confirmation"}>{"Pending Confirmation"}</MenuItem>
                      <MenuItem value={"Unreachable"}>{"Unreachable"}</MenuItem>
                      <MenuItem value={"Preparing"}>{"Preparing"}</MenuItem>
                      <MenuItem value={"Prepared"}>{"Prepared"}</MenuItem>
                      <MenuItem value={"Ready for Pickup"}>{"Ready for Pickup"}</MenuItem>
                      <MenuItem value={"In Transit"}>{"In Transit"}</MenuItem>
                      <MenuItem value={"Delivered"}>{"Delivered"}</MenuItem>
                      <MenuItem value={"Returned"}>{"Returned"}</MenuItem>
                      <MenuItem value={"Returned to Chainz"}>{"Returned to Chainz"}</MenuItem>
                      <MenuItem value={"Cancelled"}>{"Cancelled"}</MenuItem>
                      <MenuItem value={"Sold Out"}>{"Sold Out"}</MenuItem>
                    </MainInput>
                  </Grid>
                  <Grid item xs={12}>
                    <BrandSelect
                      vendors={vendors}
                      value={vendorId}
                      label="Vendor"
                      emptyLabel="All Vendors"
                      emptyValue={null}
                      fullWidth
                      margin="none"
                      sx={{ mt: 1 }}
                      onChange={(id) => setVendorId(id)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography>Date Range</Typography>
                    <DateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      onChange={({ startDate: s, endDate: e }) => {
                        setStartDate(s || null);
                        setEndDate(e || null);
                        if (s && e) {
                          handleSearch({ startDate: s, endDate: e });
                        }
                      }}
                      fullWidth
                      margin="normal"
                      placeholder="Select date range"
                    />
                  </Grid>
                  <Grid item xs={2} sx={{ ...centered_flex_box }}>
                    <Button sx={{ ...main_button }} fullWidth onClick={() => clearAllFilters()}>Clear All</Button>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Collapse>
        <OrdersTable
          orders={orders?.docs}
          pagination={orders}
          page={page}
          setPage={setPage}
          loading={isLoading}
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  orders: state?.records?.orders,
  vendors: state?.records?.vendors,
  warehouses: state?.records?.warehouses?.docs
});

const mapDispatchToProps = { getOrders, getWarehouses, getVendors };

export default connect(mapStateToProps, mapDispatchToProps)(OrdersList);
